import { render } from "./embedded_feedback_widget.vue?vue&type=template&id=515c43ed"
import script from "./embedded_feedback_widget.vue?vue&type=script&lang=js"
export * from "./embedded_feedback_widget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__